<template>
    <div class="pause display--flex">
        <timer v-bind="{ action: actions.logout }"/>
        <base-button
            type="button"
            class="pause__button background--green color--white"
            v-html="$t('global.backToOperate')"
            @click="actions.request( 'pause' )"
        />
    </div>
</template>

<script>
export default {
    components: {
        Timer: () => import( /* webpackChunkName: 'Timer' */ '@/components/bundles/operate/blocks/Timer' ),
        BaseButton: () => import( /* webpackChunkName: 'BaseButton' */ '@/components/bundles/buttons/BaseButton' )
    },
    props: {
        actions: Object
    },
    setup () {

    }
};
</script>

<style lang="scss">
    .pause {
        @include position-grid( center, center );
        flex-direction: column;
        @include dimensions( 100%, 100% );
        &__button {
            max-width: 320px;
            @include typography-specs( 20px, 20px, 400 );
            margin-top: 30px;
        }
    }
</style>